<template>
  <v-main class="equity-detail-page">
    <v-app-bar app flat light color="white">
      <AppbarBackIcon />
      <v-toolbar-title class="font-weight-bold">
        <span>权益</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!isCreate" color="red" class="ml-4" outlined small @click="onDelete">删除</v-btn>
    </v-app-bar>
    <v-container fluid>
      <v-row dense v-if="!isCreate && equity">
        <v-col cols="12">
          <v-text-field label="权益ID" :value="equity.id" readonly />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="7">
          <v-text-field label="名称" class="required" hint="例如：会员、高级会员" v-model="form.name" />
        </v-col>
        <v-col cols="5">
          <v-select
            class="required"
            label="模式"
            right
            :readonly="!isCreate"
            :items="patternList"
            v-model="form.pattern"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-text-field label="别名" hint="用于代码中引用，例如：equity_vip" v-model="form.alias" />
        </v-col>
      </v-row>
      <v-row dense v-if="!isPromoter">
        <v-col cols="7">
          <SelectEquityGroup class="required" v-model="form.group_id" :pattern="form.pattern" allow-virtual />
        </v-col>
        <v-col cols="5">
          <v-text-field
            class="required"
            label="组内排序"
            type="number"
            v-model="form.index"
            hint="权益在分组内从小到大排序"
            :rules="indexRules"
            min="0"
          />
        </v-col>
      </v-row>
      <v-row dense v-if="isPromoter">
        <v-col cols="12">
          <InputProfitRatioField class="required" label="佣金比例" v-model="form.profit_ratio" />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <InputEquityAmount
            :label="equityAmountLabel"
            hint="用户注册后自动获得的会员时长/积分数量"
            :pattern="form.pattern"
            v-model="form.initial_amount"
            disable-infinite
          />
        </v-col>
      </v-row>
      <v-row dense v-if="isPromoter">
        <v-col cols="12">
          <SelectList
            v-model="form.promoter_product_id_s"
            label="商品"
            title="推广码商品"
            :options="product_option_s"
          ></SelectList>
        </v-col>
      </v-row>
      <v-btn width="100%" color="primary" class="mt-8" @click="onSave">保存</v-btn>
    </v-container>
  </v-main>
</template>

<script>
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import InputEquityAmount from '@/components/InputEquityAmount.vue'
import InputProfitRatioField from '@/components/InputProfitRatioField.vue'
import SelectEquityGroup from '@/components/SelectEquityGroup.vue'
import SelectList from '@/components/SelectList.vue'
import { EquityPattern } from '@/plugins/payment'
import { equityStore } from '@/store/equity'
import { homeStore } from '@/store/home'
import { productStore } from '@/store/product'
import _ from 'lodash'

const patternList = [
  {
    text: '订阅/永久',
    value: EquityPattern.SUBSCRIPTION,
  },
  {
    text: '积分/消耗品',
    value: EquityPattern.CONSUMABLE,
  },
  {
    text: '推广员',
    value: EquityPattern.PROMOTER,
  },
]

export default {
  name: 'EquityDetailPage',
  components: {
    AppbarBackIcon,
    InputEquityAmount,
    InputProfitRatioField,
    SelectEquityGroup,
    SelectList,
  },
  data() {
    return {
      patternList,
      form: {
        name: '',
        alias: '',
        pattern: patternList[0].value,
        group_id: null,
        index: null,
        initial_amount: null,
        profit_ratio: null,
        promoter_product_id_s: [],
      },
      indexRules: [
        value => {
          return !_.isNil(value) && value >= 0
        },
      ],
    }
  },
  computed: {
    id() {
      return this.$route.query.id || null
    },
    isCreate() {
      return _.isNil(this.id)
    },
    equity() {
      return equityStore.get(this.id)
    },
    equityAmountLabel() {
      if (this.form.pattern == EquityPattern.CONSUMABLE) {
        return '免费试用额度'
      } else {
        return '免费试用时长'
      }
    },
    isPromoter() {
      return this.form.pattern === EquityPattern.PROMOTER
    },
    product_option_s() {
      return productStore.list.map(product => {
        let redeem = product.is_redeem ? '可兑换' : '不可兑换'
        return {
          text: `${product.name} - ${redeem}`,
          value: product.id,
        }
      })
    },
  },
  async mounted() {
    await homeStore.doLoad()
    await equityStore.doLoad()
    await productStore.doLoad()
    if (!this.isCreate && this.equity) {
      this.form.name = this.equity.name
      this.form.alias = this.equity.alias
      this.form.pattern = this.equity.pattern
      this.form.group_id = this.equity.group_id
      this.form.index = this.equity.index
      this.form.initial_amount = this.equity.initial_amount
      this.form.profit_ratio = this.equity.profit_ratio
      this.form.promoter_product_id_s = this.equity.promoter_product_id_s || []
    }
  },
  methods: {
    async onSave() {
      let equity = await equityStore.doSave({
        id: this.id,
        ...this.form,
      })
      if (this.isCreate) {
        this.$router.replace({ query: { id: equity.id } })
      }
      this.$toasted.success('保存成功')
    },
    async onDelete() {
      const msg = `确定要删除权益「${this.equity.name}」吗`
      if (!(await this.$dialog.confirm({ text: msg }))) {
        return
      }
      await equityStore.doDelete(this.id)
      this.$toasted.success('删除成功')
      this.$router.back()
    },
  },
}
</script>

<style lang="less" scoped></style>
